import React from "react";
import "./chatbotfooter.scss";
import { useSelector } from "react-redux";
export default function Chatbotfooter({ BgColor }) {
  const { selectedProject } = useSelector((state) => state.project);
  const { origin } = window.location;
  return (
    <div
      className="chat-bot-footer"
      style={{
        background: selectedProject?.base_color?.includes("gradient")
          ? selectedProject?.base_color
          : `linear-gradient(180deg, ${BgColor} 0%, ${selectedProject?.base_color} 100%)`,
      }}
    >
      <a href={selectedProject?.agent_name || origin} target="_blank" rel="noreferrer">
        <span style={{ color: selectedProject?.text_color }}>
          Powered By {selectedProject?.project_moto || "Brand Name"}
        </span>
      </a>
    </div>
  );
}
